import { ComponentHeading, Context } from '../content';
import { Params } from '../data';

export enum EventName {
  PageViewed = 'Page Viewed',
  PageElementViewed = 'Page Element Viewed',
  ChartInteractions = 'Chart Interactions',
  FilterApplied = 'Filter Applied',
  FilterAppliedDetails = 'Filter Applied Details',
  NavigationClicked = 'Navigation Clicked',
  PageElementClicked = 'Page Element Clicked',
  TableClicked = 'Table Clicked',
  DataExported = 'Data Exported',
  DataExportInitiated = 'Data Export Initiated',
  SearchClicked = 'Search Clicked',
  PageScrolled = 'Page Scrolled',
}

export enum EventElementType {
  Button = 'Button',
  Group = 'Group',
  Card = 'Card',
  Link = 'Link',
  Sort = 'Sort',
  Overlay = 'Overlay',
  CheckBox = 'Check Box',
}

export enum EventElementCategory {
  CustomFilter = 'Custom Filter',
  SaveFilter = 'Saved Filters',
  CustomPriceFilter = 'Custom Price Filter',
  CustomFeatureFilter = 'Custom Feature Filter',
  DeleteFeatureFilter = 'Delete Feature Filter',
  ShareFeatureFilter = 'Share Feature Filter',
}

export enum EventKeyIndicators {
  Market = 'Market',
  Brand = 'Brand',
}

export type EventParams = Record<string, string | string[]>;

export type InternalTrackingMeta = {
  componentContext?: Params;
  componentHeading?: ComponentHeading;
  eventParams: EventParams;
};

export type TrackingMeta = {
  pageUrl: string;
  pageContext: Params;
  pageTitle: string;
} & InternalTrackingMeta;

export enum TrackingElementType {
  Tooltip = 'Tooltip',
  Selectors = 'Selectors',
  Table = 'Table',
  Chart = 'Chart',
}

export type TrackingEventOptions = {
  fireEvent?: boolean;
  context?: Context;
};

export type ExternalTrackingFn = (
  event: EventName | string,
  meta: TrackingMeta,
  options?: TrackingEventOptions
) => void;
export type InternalTrackingFn = (
  event: EventName | string,
  meta: InternalTrackingMeta,
  options?: TrackingEventOptions
) => void;
export type BasicTrackingFn = (
  event: EventName | string,
  eventParams?: EventParams,
  options?: TrackingEventOptions
) => void;
export type ExternalGetTrackingTagsFn = (event: EventName | string, meta: TrackingMeta) => EventParams;
export type InternalGetTrackingTagsFn = (event: EventName | string, meta: InternalTrackingMeta) => EventParams;
export type BasicGetTrackingTagsFn = (event: EventName | string, eventParams?: EventParams) => EventParams;
export type PropositionSection = 'Market 2.0' | 'Supply Chain';
